/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, w, SCS) {
	'use strict';
	/*jshint smarttabs:true */

	function uuid() {
		// jshint bitwise: false
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}

	// IE8 fix
	document.createElement('video');

	/**
	 * BrightcoveVideo module implementation.
	 *
	 * @author Thomas Junghans (refactored by Dave Talamona, Benjamin Berger)
	 * @namespace Tc.Module
	 * @class BrightcoveVideo
	 * @extends Tc.Module
	 */
	Module.BrightcoveVideo = Module.extend({

		/* Runtime properties */
		// The videojs player instance.
		player: null,

		// The current video metadata
		currentVideo: null,

		// The interval for the ugly hack that causes flash to throw an exception when it has died so we know when to reload the player.
		flashHideErrorTriggerInterval: null,

		// The interval that counts down the skip-ad timeout and activates the skip button.
		skipAdTimeoutInterval: null,

		// How many milliseconds of the ad timeout have elapsed.
		skipAdTimeoutElapsed: 0,

		// This video’s id attribute value (generated by the module).
		id: null,

		/* Config attributes */
		// Whether the video starts automatically.
		autostart: false,

		// Whether the video loops.
		loop: false,

		// How long one has to wait before being allowed to skip an ad, in milliseconds.
		skipAdTimeout: 8000,

		// The URL for the VAST tag. Null if not yet initialized or ads are disabled.
		adServerUrl: null,

		// Whether this video is in an overlay
		isInOverlay: false,

		// Whether the player was reloaded because of a technical problem.
		// If this is the case, ads should not be shown again because they might have caused the problem.
		wasReloaded: false,

		// Whether the player is currently showing an ad (playing or paused).
		currentlyShowingAds: false,

		/* Module elements */
		// The container for this video. This element is responsible for creating the correct aspect ratio.
		// If the player is in an overlay, this is the element that gets overlaid.
		$videoContainer: null,

		// The div that contains the video tag.
		$wrapper: null,

		// A div with the same attributes as the video tag, from which the video tag can be generated.
		$dummyVideoTag: null,

		// The actual video tag. Careful, this might not be what you expected (if you expected a <video> tag attached to the document):
		// * null if the video tag has not yet been initialized
		// * a <video> tag not attachted to the document (if it has been replaced by flash)
		$videoTag: null,

		// The button on which to click when skipping an ad.
		$skipAdsButton: null,

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method after
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			mod.$videoContainer = mod.$ctx.find('.video-container');
			mod.$dummyVideoTag = mod.$videoContainer.find('.dummyVideoTag');
			mod.$dummyVideoTag.remove();

			callback();
		},

		after: function () {
			var mod = this;

			// Store calls to the API that were made before the player was ready
			mod.apiCache = {};
			mod.setupAPI();

			// Get attributes
			mod.autostart = mod.$ctx.data('autostart');
			mod.loop = mod.$ctx.data('loop');
			mod.skipAdTimeout = parseInt(mod.$ctx.attr('data-skip-ad-timeout'), 10) * 1000 || mod.skipAdTimeout;
			mod.isInOverlay = mod.$ctx.data('is-in-overlay');

			if (mod.debug) {
				window.modBrightcoveVideo = mod;
			}

			mod.$wrapper = mod.$videoContainer.find('.video-player-wrapper');
			mod.$skipAdsButton = mod.$ctx.find('.skipAdsButton');

			mod.loadBrightcove($.proxy(mod, 'preparePlayer'));

			mod.initVideoPlaybutton();
		},

		setupAPI: function () {
			var mod = this;

			mod.$ctx.on('onPause', function () {
				mod.pause();
				mod.log('on pause API called');
			});

			mod.$ctx.on('onPlay', function () {
				mod.play();
				mod.log('on play API called');
			});

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-hide', function () {
				mod.pause();
			});

			mod.$ctx[0].brightcoveapi = {
				play: $.proxy(mod, 'play'),
				pause: $.proxy(mod, 'pause'),
				getPlayer: $.proxy(mod, 'getPlayer'),
				isPlaying: $.proxy(mod, 'isPlaying'),
				dispose: $.proxy(mod, 'dispose'),
				getModule: function getModule() {
					return mod;
				}
			};

			mod.$ctx.data('brightcove-api', mod.$ctx[0].brightcoveapi);
		},

		loadBrightcove: function loadBrightcove(callback) {
			var mod = this;

			if (window.bc && window.videojs) {
				callback();
			} else {
				if (loadBrightcove.loaders) {
					loadBrightcove.loaders.push(callback);
					return;
				}
				loadBrightcove.loaders = [callback];
				var url = mod.$ctx.data('playerScript');
				if (mod.debug) {
					url = url.replace(/\.min\.js$/, '.js');
				}
				mod.log('loading window.bc from ' + url);
				$.ajax({
					url: url,
					cache: true,
					dataType: 'script',
					success: function () {
						mod.log('loaded window.bc', typeof window.bc, typeof window.videojs, loadBrightcove.loaders.length);
						for (var i = 0; i < loadBrightcove.loaders.length; i += 1) {
							loadBrightcove.loaders[i]();
						}
						delete loadBrightcove.loaders;
					}
				});
			}
		},

		preparePlayer: function () {
			var mod = this;
			mod.initPlayer();
		},

		initPlayer: function () {
			var mod = this;

			if (mod.player) {
				mod.log('Player reloaded because of a technical problem');
				mod.wasReloaded = true;
			}

			mod.createVideo();

			var video = mod.$videoTag[0];
			try {
				// this call is very important so Brightcove can mess around with the video tag
				// before we init the real vjs component that we will use
				window.bc(video);
			} catch (e) {
				// If brightcove has already transformed the video tag, we get an error. That’s ok.
			}

			window.videojs(video).ready(function () {
				var player = this;
				mod.log('videojs ready', mod.id, video, player);
				if (player.techName === 'Flash') {
					mod.prepareFlashPlaybackHack(player);
				}
				mod.setupPlayer(player);
			});
		},

		prepareFlashPlaybackHack: function (player) {
			var techCall = player.techCall;
			player.techCall = function (method) {
				if (method === 'play') {
					// Call play twice to combat flash not starting the first time around
					techCall.apply(this, arguments);
				}
				techCall.apply(this, arguments);
			};
		},

		// Create the <video> element that is then used to initialize brightcove
		createVideo: function () {
			var mod = this;

			mod.id = uuid();
			var attrs = {
				poster: mod.$dummyVideoTag.attr('data-poster'),
				'class': mod.$dummyVideoTag.attr('data-class'),
				controls: true,
				id: mod.id
			};
			for (var name in mod.$dummyVideoTag.data()) {
				// jshint forin: false
				// de-camelize name
				name = 'data-' + name.replace(/([a-z\d])([A-Z])/g, '$1' + '-' + '$2').toLowerCase();
				var value = mod.$dummyVideoTag.attr(name);

				attrs[name] = value;
			}

			mod.$videoTag = $(document.createElement('video'));

			if(!mod.$ctx.closest('.stagearea').length) {
				attrs.preload = 'metadata';
			}
			mod.$videoTag.attr(attrs);

			mod.$wrapper.empty();
			mod.$wrapper.append(mod.$videoTag);
		},

		setupPlayer: function (player) {
			var mod = this;

			// Clean up the old player (if any)
			mod.cleanup();
			/* Initialize state */
			// get a reference to the player
			mod.player = player;
			mod.skipAdTimeoutElapsed = 0;

			mod.log('setupPlayer bc video');

			mod.$wrapper.find('.video-js').css('left', '0px');
			mod.$ctx.find('.video-js').css({width: '100%', height: '100%'});

			mod.player.loop(mod.loop);
			//mod.player.autoplay(mod.autostart);
			mod.log('setting autoplay: ' + mod.autostart + ', loop: ' + mod.loop);

			// TODO could be saved in a cookie for next use of player or at least sync with other players on same page
			mod.player.volume(0.5);

			mod.setupPlayerLoad();
			mod.setupPlayerEvents();

			if (mod.videoOnHold){
				mod.onBrightcovePlayVideo(mod.videoOnHold);
				delete mod.videoOnHold;
			}

			try {
				mod.setupPlayerAds();
			} catch (e) {
				mod.log('setting up ads crashed', e);
				mod.setNotShowingAds();
			}

			// Re-run the calls to the API that were made before the player was ready
			for (var api in mod.apiCache) {
				if (!mod.apiCache.hasOwnProperty(api)) {
					continue;
				}
				this[api]();
			}

			mod.$ctx.addClass('scs-setup-and-ready');
		},

		cleanup: function () {
			var mod = this;
			if (mod.skipAdTimeoutInterval) {
				window.clearInterval(mod.skipAdTimeoutInterval);
			}
			if (mod.flashHideErrorTriggerInterval) {
				window.clearInterval(mod.flashHideErrorTriggerInterval);
			}
			if (mod.player) {
				mod.player.dispose();
				mod.player = null;
			}
		},

		setupPlayerLoad: function () {
			var mod = this;

			mod.log('trigger handler for player-loaded');
			// Trigger event for parent modules to react to and re-calculate sizes and stuff.
			mod.$ctx.trigger('brightcove.playerloaded');
		},

		setupPlayerEvents: function () {
			var mod = this;

			var isFirst = true;

			mod.player.on('loadstart', function (event) {
				mod.log('got loadstart event', event);
				var video = mod.player.mediainfo;

				mod.videoChanged(mod, video, isFirst);
				if (isFirst) {
					mod.initialVideoChanged(mod, video);
					isFirst = false;
				}
			});
			mod.player.on('ended', function (event) {
				mod.log('got ended event', event);
				mod.videoFinished(mod.player.mediainfo, mod);
			});
			mod.player.on('error', function (event) {
				mod.log('got error event', event);
				if (mod.player.ads && mod.currentlyShowingAds) {
					// Error was caused by an ad. Re-init the player (no ads will be shown this time).
					mod.initPlayer();
				}
			});
			mod.player.on('bc-catalog-error', function (event) {
				mod.log('got bc-catalog-error event', event);
				// Wait a few seconds, then re-init the player
				window.setTimeout(function () {
					mod.initPlayer();
				}, 2000);
			});

			mod.player.on('pause', function(event) {
				mod.log('got pause event', event);
				mod.$ctx.addClass('is-paused').removeClass('is-playing');
			});
			mod.player.on('play', function(event) {
				mod.log('got play event', event);
				mod.$ctx.removeClass('is-paused').addClass('is-playing');
			});
			mod.player.on('firstplay', function(event) {
				mod.log('got firstplay event', event);
				mod.$ctx.removeClass('is-idle').addClass('has-started');
			});

			var hasLoaded = !!mod.player.mediainfo;
			if (hasLoaded) {
				mod.player.trigger('loadstart');
			}
		},

		getAdVars: function () {
			var mod = this,
				vars = '';

			// window.bwAdVars is set by persad.js
			for (var k in window.bwAdVars) {
				if (k.indexOf('kv') === 0) {
					vars += ';' + k + '=' + window.bwAdVars[k];
				}
			}
			mod.log('getAdVars > vars=' + vars);
			return vars;
		},

		setupPlayerAds: function () {
			var mod = this;
			mod.adServerUrl = null;

			mod.log('setupPlayerAds', mod.player.ima3, mod.wasReloaded);

			if (!mod.player.ima3 || !mod.player.ima3.adrequest) {
				mod.log('ima3 not present');
				return;
			}

			if (mod.wasReloaded) {
				// Do not show ads twice if player was reloaded because of a technical problem.
				mod.wasReloaded = false;
				return;
			}

			// Get the brightcove ad configuration
			mod.adServerUrl = mod.getAdServerUrl();

			// debug ad URL, leave this comment in
			//mod.adServerUrl = "https://cs1.brightcodes.net/gamati/AdServer/AdExampleForTest.xml";
			if (!mod.adServerUrl) {
				return;
			}

			mod.player.ima3.settings.requestMode = 'onplay';
			mod.player.ima3.settings.serverUrl = mod.adServerUrl + mod.getAdVars();

			// 20 vast request redirects: PORTAL-11593
			// see docu https://docs.brightcove.com/en/perform/brightcove-player/guides/ima-plugin.html#methods
			mod.player.ima3.settings.ima3SdkSettings = { numRedirects : 20};

			mod.$wrapper.find('.video-js').append(mod.$skipAdsButton);
			mod.$ctx.find('.skipAdForReal').click($.proxy(mod.skipAd, mod));
			mod.updateSkipAdsButtonState();

			// Register adstart and adend listeners to start skip countdown
			mod.player.on('adstart', function (event) {
				mod.log('got adstart event', event);
				mod.setShowingAds();
			});

			mod.player.on('adend', function (event) {
				mod.log('got adend event', event);
				mod.setNotShowingAds();
			});

			mod.player.on('ima3-ad-error', function (event) {
				mod.log('got ima3-ad-error event', event);
				mod.setNotShowingAds();
				mod.play();
			});

			// Log
			if(mod.debug) {
				[
					'ima3error',
					'ads-request',
					'ads-load',
					'adsready',
					'adtimeout',
					'ads-ad-started',
					'ads-ad-ended',
					'ads-pause',
					'ads-play',
					'ads-first-quartile',
					'ads-midpoint',
					'ads-third-quartile',
					'ads-click',
					'ads-volumechange',
					'ads-pod-started',
					'ads-pod-ended',
					'ads-allpods-completed'
				].forEach(function(type) {
					mod.player.on(type, function (event) {
						mod.log('got '+type+' event', event);
					});
				});
			}
		},

		/*triggerAdRequest: function() {
			var mod = this;
			if(!mod.adServerUrl) {
				// No ads configured on page
				return;
			}
			if(window.google && window.google.ima) {
				mod.log('requesting ads from', mod.adServerUrl);
				mod.player.ima3.adrequest(mod.adServerUrl);
			} else {
				mod.player.on('ima3-ready', function(event) {
					// initialize the ima3 plugin that was registered in ima3.min.js with custom options
					mod.log('got ima3-ready event', event, 'now requesting ads from', mod.adServerUrl);
					mod.player.ima3.adrequest(mod.adServerUrl);
				});
			}
		},*/

		getAdServerUrl: function () {
			var mod = this;

			if (!mod.player.ima3) {
				mod.log('don’t configure ads because they seem to be turned off', mod.player.ima3);
				return;
			}
			if(mod.$ctx.data('ad-pre') && mod.$ctx.data('ad-pre').length) {
				return mod.$ctx.data('ad-pre');
			}
			else if(mod.$ctx.data('ad-post') && mod.$ctx.data('ad-post').length) {
				return mod.$ctx.data('ad-post');
			}

			mod.log('!prerollAds && !postrollAds');
		},

		setShowingAds: function () {
			var mod = this;
			mod.log('setShowingAds', mod.skipAdTimeoutElapsed, mod.skipAdTimeout);

			mod.currentlyShowingAds = true;
			$('.disablePlaylist').css({zIndex: 1}).show();

			if (mod.skipAdTimeoutElapsed >= mod.skipAdTimeout) {
				// Something went wrong: ads were already shown
				return;
			}
			mod.$skipAdsButton.removeClass('hiddenSkip');
			mod.startAdSkipCountdown();
		},

		setNotShowingAds: function () {
			var mod = this;
			mod.log('setNotShowingAds');

			mod.currentlyShowingAds = false;
			$('.disablePlaylist').hide();

			mod.pauseAdSkipCountdown();
			mod.skipAdTimeoutElapsed = 0;
			mod.$skipAdsButton.addClass('hiddenSkip');
		},

		startAdSkipCountdown: function () {
			var mod = this;
			mod.log('startAdSkipCountdown');
			mod.$skipAdsButton.removeClass('hiddenSkip');

			if (mod.skipAdTimeoutInterval) {
				// Already an interval active… do nothing
				// FIXME: Why not clear the old interval and create a new one?
				return;
			}

			// Make sure the buttons have the correct initial state
			mod.updateSkipAdsButtonState();

			if (mod.skipAdTimeoutElapsed >= mod.skipAdTimeout) {
				return;
			}

			var startDate = + new Date();
			// Store the initial time (if it’s not 0)
			var elapsed = mod.skipAdTimeoutElapsed;
			mod.skipAdTimeoutInterval = setInterval(function () {
				mod.skipAdTimeoutElapsed = elapsed + (+new Date()) - startDate;
				mod.updateSkipAdsButtonState();
			}, 500);
		},

		updateSkipAdsButtonState: function () {
			var mod = this;
			var postSkip = mod.skipAdTimeoutElapsed >= mod.skipAdTimeout;
			mod.$skipAdsButton.toggleClass('preSkip', !postSkip);
			mod.$skipAdsButton.toggleClass('postSkip', postSkip);
			if(mod.player && mod.player.ima3 && mod.player.ima3.adsManager) {
				mod.$skipAdsButton.find('.skipAdRest .secTimer').text(Math.ceil(mod.player.ima3.adsManager.getRemainingTime()));
			}
			mod.$skipAdsButton.find('.skipAdCountdown .secTimer').text(Math.ceil((mod.skipAdTimeout - mod.skipAdTimeoutElapsed)/1000));
		},

		pauseAdSkipCountdown: function () {
			var mod = this;
			if (mod.skipAdTimeoutInterval) {
				clearInterval(mod.skipAdTimeoutInterval);
				mod.skipAdTimeoutInterval = null;
			}
		},

		skipAd: function () {
			var mod = this;
			if (mod.player.ads) {
				if (mod.player.ima3.adsManager) {
					mod.player.ads.endLinearAdMode();
					mod.player.ima3.adsManager.pause();
					mod.player.ima3.adsManager.skip();
					mod.log('skipped ad');
				} else {
					mod.log('can’t skip cause this is the ima3', mod.player.ima3);
				}
			}
		},

		detectAndroidPhone: function () {
			var ua = navigator.userAgent.toLowerCase(),
				isAndroid = ua.indexOf('android') > -1;

			return isAndroid ? true : false;
		},

		initVideoPlaybutton: function () {
			var mod = this,
				$ctx = mod.$ctx,
				$videoPlaybutton = $ctx.find('.video-playbutton-container');

			$videoPlaybutton.click(function () {
				mod.play();
			});

			// detect android phones
			if (mod.detectAndroidPhone()) {
				// show play button placeholder
				// set class to hide webkit default controls
				$ctx.addClass('is-android');
			}
		},

		// API
		getPlayer: function () {
			return this.player;
		},

		pause: function () {
			var mod = this;

			if (mod.player) {
				mod.player.pause();
			} else {
				mod.apiCache.pause = true;
			}
		},

		play: function () {
			var mod = this;
			if (mod.player) {
				mod.player.play();
			} else {
				mod.apiCache.play = true;
			}
		},

		isPlaying: function () {
			var mod = this;
			if (mod.player) {
				return !mod.player.paused();
			}
			return mod;
		},

		dispose: function () {
			var mod = this;
			mod.cleanup();
			for (var name in mod) {
				if (mod.hasOwnProperty(name)) {
					mod[name] = null;
				}
			}
		},

		initialVideoChanged: function (mod, video) {
			mod.log('fire brightcoveFirstVideoReady');
			mod.fire('brightcoveFirstVideoReady', {'currentVideoId': parseInt(video.id, 10), 'tags': video.tags, 'thumbnailURL': video.thumbnail, 'name': video.name});
			if (mod.isInOverlay) {
				mod.trackVideoPageCall(mod.createUrl(video.id, video.name));
			}
		},

		videoChanged: function (mod, video, isFirst) {
			mod.updateAspectRatio(video);
			mod.log('videoChanged', mod.$dummyVideoTag.attr('data-video-id'), video.id);
			// Update the video id in case we need to reload the player using initPlayer()
			mod.$dummyVideoTag.attr('data-video-id', video.id);

			// Only update to new video if it is a different video, because this can be called multiple times at startup because of ads, etc.
			if (!isFirst && mod.currentVideo && video.id !== mod.currentVideo.id) {
				var data = {'currentVideoId': video.id, 'name': video.name, 'description': video.description};
				mod.fire('brightcoveChangedVideoReady', data);
				window.setTimeout(function () {
					mod.updateToNewVideo(data);
				}, 10); // keep in separate “thread” so that any IE-errors with the player do not stop the action

				mod.log('fire brightcoveChangedVideo > currentVideoId = ' + video.id);
			}

			/*if(mod.player.paused()) {
				// Register listener for next play
				mod.player.one('play', function initialPlay() {
					mod.log('initial play after video change');
					// Trigger the ad request on first play after loadstart
					mod.triggerAdRequest();
				});
			} else {
				// Already playing: call ad request directly
				mod.triggerAdRequest();
			}*/

			var newUrl = mod.createUrl(video.id, video.name);

			mod.log('fire urlChanged', newUrl);
			mod.sendUrlChangeToModules({
				url: newUrl,
				title: video.name,
				description: video.description
			});

			// save current video for check next time
			mod.currentVideo = video;

			// reset initial timeout for skipping ads
			mod.skipAdTimeoutElapsed = 0;

			if(mod.autostart) {
				setTimeout(function() {mod.play();}, 10);
			}
		},

		videoFinished: function (video, mod) {
			if (video) {
				mod.fire('brightcoveFinishedVideo', {'currentVideoId': video.id});
				mod.log('fire brightcoveFinishedVideo > currentVideoId = ' + video.id);
			}
		},

		updateAspectRatio: function (video) {
			var mod = this;

			var largestSource = null,
				sourcesLength = video.sources ? video.sources.length : 0;
			for (var i = 0; i < sourcesLength; i += 1) {
				var source = video.sources[i];
				if (('width' in source && 'height' in source) && (largestSource === null || largestSource.width < source.width)) {
					largestSource = source;
				}
			}

			var aspectRatio = 4 / 3;
			if (largestSource) {
				aspectRatio = largestSource.width / largestSource.height;
			}

			mod.$wrapper.css({paddingBottom: '' + (100 / aspectRatio) + '%'});
		},

		onBrightcovePlayVideo: function (data) {
			var mod = this;

			if (mod.isPlaying()) {
				mod.pause();
			}

			if (!mod.player){
				mod.log('Player not initialized, storing id: ' + data.currentVideoId);
				mod.videoOnHold = data;
				return;
			}

			mod.player.catalog.getVideo(data.currentVideoId, function (error, video) {
				if (error) {
					mod.log('Loading video mediainfo failed for ' + data.currentVideoId);
					return;
				}
				// This will trigger a “loadstart” event
				try {
					mod.player.catalog.load(video);
				} catch (e) {
					mod.log('Loading video failed for id_' + data.currentVideoId);
					mod.log('Try again, to load video for id_' + data.currentVideoId);
					//try again
					mod.player.catalog.load(video);
				}
			});
		},

		updateToNewVideo: function (data) {
			// update title/url and fire urlupdated
			var mod = this,
				videoId = data.currentVideoId,
				videoTitle = data.name,
				videoDescription = data.description,
				url = mod.createUrl(videoId, videoTitle);

			mod.log('onBrightcoveChangedVideo > currentVideoId = ' + data.currentVideoId);

			if (!mod.isInOverlay && window.history && window.history.pushState) {
				window.history.pushState(null, videoTitle, url);
			}

			if (!mod.isInOverlay) {
				document.title = videoTitle;
				$('.modBrightcoveVideo h1.title').text(videoTitle);
			}
			else {
				$('.sc-overlay-container .modBrightcoveVideo h1.title').text(videoTitle);
			}

			if (videoDescription) {
				mod.$ctx.find('.lead p').text(videoDescription);
			}
			else {
				mod.$ctx.find('.lead p').text('');
			}

			// track video page call
			mod.trackVideoPageCall(url);


		},

		createUrl: function (id, title) {
			var mod = this,
				currentUrl = mod.$ctx.data('video-page-url') || document.location.href;
			if (currentUrl.indexOf('http') !== 0) {
				currentUrl = $('<a />').attr('href', currentUrl)[0].href; // make url absolute
			}

			currentUrl = currentUrl.replace(/\.galleryoverlay\./g, '.');

			var urlParts = currentUrl.split('.');

			var html = urlParts.pop();
			if (html !== 'html') {
				// Not an ordinary page => do nothing
				return currentUrl;
			}

			// Cut off the first “id-” (if found) and everything that follows (should mostly include the title)
			for (var i = 0; i < urlParts.length; i += 1) {
				if (urlParts[i].indexOf('id-') === 0) {
					urlParts = urlParts.slice(0, i);
					break;
				}
			}

			// Add the id to the url
			urlParts.push('id-' + id);

			// Add the (normalized) title to the url
			urlParts.push((!title || title.length < 2) ? 'notitle' : SCS.Url.getValidSelector(title).toLowerCase());

			// Add the html again
			urlParts.push(html);

			return urlParts.join('.')+(document.location.search||'');
		},

		trackVideoPageCall: function () {
			// Net-Metrix
			// jshint camelcase: false
			if (window.NETMX_track) {
				window.NETMX_track();
			}
		},

		sendUrlChangeToModules: function (data) {
			var mod = this;
			if (mod.isInOverlay) {
				$('.sc-overlay-container .mod[data-connectors*=urlchange]').each(function () {
					var tempMod = mod.sandbox.getModuleInstance(this);
					if (tempMod && tempMod.onUrlChanged) {
						tempMod.onUrlChanged(data);
					}
				});
			}
			else {
				mod.fire('urlChanged', data);
			}
		},

		onToggleVisibility: function(data) {
			var mod = this;
			// jshint unused: false
			if (this.$ctx.is(':visible')) {
				mod.log('toggleVisibility event called > player visible');
				if (!this.player) {
					this.initPlayer();
				}
			}
			else {
				mod.log('toggleVisibility event called > player hidden');
				if (this.player) {
					this.cleanup();
				}
			}
		}

	});

}(window.Tc.Module, window.Tc.$, window, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/base/clientlibs/shared/js/modules/Tc.Module.BrightcoveVideo.js
// module id = 326
// module chunks = 0